import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { NavMarker } from 'react-rhumb';
import { KOALA } from 'HubStyleTokens/colors'; //@ts-expect-error Could not find declaration file for module

import VidyardVideoPlayer from 'ui-addon-video-player/components/VidyardVideoPlayer';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner'; //@ts-expect-error Could not find declaration file for module

import ApiError from '../../Errors/ApiError';
import UIImage from 'UIComponents/image/UIImage';
import { OLAF } from 'HubStyleTokens/colors';
import { device } from '../../../constants/StyledComponentConstants';
import DeprecatedError from '../../Errors/DeprecatedError';
const OVERVIEW_MAX_CONTENT_WIDTH = 1180;
const OverviewContentContainer = styled.div.withConfig({
  displayName: "OverviewContent__OverviewContentContainer",
  componentId: "sc-1s99gp0-0"
})(["position:relative;min-height:100%;max-width:100%;display:flex;flex-direction:column;align-self:", ";"], props => props.$isLoading ? 'center' : 'normal');
const HeaderIconWrapper = styled.div.withConfig({
  displayName: "OverviewContent__HeaderIconWrapper",
  componentId: "sc-1s99gp0-1"
})(["position:absolute;right:26px;top:24px;@media screen and ", "{right:68px;}"], device.mobile);
const Loader = styled(UILoadingSpinner).withConfig({
  displayName: "OverviewContent__Loader",
  componentId: "sc-1s99gp0-2"
})(["width:", "px;max-width:100%;flex:1;max-height:660px;"], OVERVIEW_MAX_CONTENT_WIDTH);
const OverviewModalContent = styled.div.withConfig({
  displayName: "OverviewContent__OverviewModalContent",
  componentId: "sc-1s99gp0-3"
})(["width:", "px;max-width:100%;position:relative;margin:0 auto;overflow:", ";"], OVERVIEW_MAX_CONTENT_WIDTH, props => props.$allowFullWidthChildren ? 'visible' : 'hidden');
const ErrorMessage = styled.div.withConfig({
  displayName: "OverviewContent__ErrorMessage",
  componentId: "sc-1s99gp0-4"
})(["width:", "px;max-width:100%;color:", ";.missing-content-error a{display:none;}"], OVERVIEW_MAX_CONTENT_WIDTH, OLAF);

const OverviewContent = ({
  deprecated,
  deprecationCta,
  loading,
  error,
  videoId,
  fallbackThumbnailUrl,
  children,
  headerIcons,
  allowFullWidthChildren = false
}) => {
  return /*#__PURE__*/_jsx(OverviewContentContainer, {
    $isLoading: loading,
    children: loading ? /*#__PURE__*/_jsx(Loader, {
      grow: true,
      size: 'medium'
    }) : deprecated ? /*#__PURE__*/_jsx(ErrorMessage, {
      children: /*#__PURE__*/_jsx(DeprecatedError, {
        deprecationCta: deprecationCta
      })
    }) : error ? /*#__PURE__*/_jsx(ErrorMessage, {
      children: /*#__PURE__*/_jsx(ApiError, {
        error: error.networkError,
        marker404: "OVERVIEW_MODAL_API_404",
        markerDefault: "OVERVIEW_MODAL_API_ERROR"
      })
    }) : /*#__PURE__*/_jsx(NavMarker, {
      name: "OVERVIEW_MODAL_LOADED",
      children: /*#__PURE__*/_jsxs(OverviewModalContent, {
        $allowFullWidthChildren: allowFullWidthChildren,
        "data-test-id": "overview-modal-content",
        children: [videoId ? /*#__PURE__*/_jsx(VidyardVideoPlayer, {
          autoPlay: true,
          captionsOnByDefault: true,
          loadingBackground: KOALA,
          mutedByDefault: true,
          preload: "auto",
          videoId: videoId
        }) : /*#__PURE__*/_jsx(UIImage, {
          alt: "thumbnail",
          "data-test-id": "fallback-thumbnail",
          src: fallbackThumbnailUrl || undefined
        }), /*#__PURE__*/_jsx(HeaderIconWrapper, {
          children: headerIcons
        }), children]
      })
    })
  });
};

export default OverviewContent;